import axios from "axios";

const BASE_URL =
  "https://u3on30ksk8.execute-api.ap-south-1.amazonaws.com/default";

export const feedbackClient = axios.create({
  baseURL: BASE_URL,
});

export const sendFeedback = async (user_id, message) => {
  try {
    const response = await feedbackClient.post("/saveReportsFeedback", {
      user_id: user_id,
      message,
    });
    return response.data;
  } catch (error) {
    console.error("Error sending feedback:", error);
    throw error;
  }
};
